var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "other-window",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7,198.1c-5.9,0-10.8-4.8-10.8-10.8V12.7c0-5.9,4.8-10.8,10.8-10.8h112.7c5.9,0,10.8,4.8,10.8,10.8v174.6 c0,5.9-4.8,10.8-10.8,10.8h0H43.7z M43.7,6.1c-3.6,0-6.6,3-6.6,6.6v174.6c0,3.6,3,6.6,6.6,6.6h112.7c3.6,0,6.6-3,6.6-6.6V12.7 c0-3.6-3-6.6-6.6-6.6H43.7z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,185.7c-1.2,0-2.1-0.9-2.1-2.1V16.4c0-1.2,0.9-2.1,2.1-2.1h105.3c1.2,0,2.1,0.9,2.1,2.1v167.2c0,1.2-0.9,2.1-2.1,2.1 H47.3z M49.4,181.5h101.1v-163H49.4V181.5z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7,131.6v-7.4h7.7v7.4H93.7z M94.7,114v-13.8h2.5c5.6,0,10.1-1,13.4-3c3.5-2.1,5.3-5.9,5.3-11.3c0-3.7-1.1-6.7-3.3-8.9 c-2.2-2.2-5.2-3.3-8.9-3.3c-3.9,0-7.1,1.1-9.4,3.4c-2.2,2-3.4,4.7-3.6,7.8h-5.8c0.1-2.9,0.9-5.5,2.3-7.8c1.5-2.5,3.8-4.5,6.6-5.9 c2.9-1.4,6.3-2.1,10.1-2.1c5.5,0,9.9,1.5,13.1,4.4c3.2,2.9,4.8,7.1,4.8,12.3c0,5.9-1.8,10.3-5.4,13.2c-3.7,2.9-8.8,4.5-15.2,4.6 l-1,0V114H94.7z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherWindow);
export default __webpack_public_path__ + "static/media/other-window.adc3abfa77305eb6b0915795be38bc33.svg";
export { ForwardRef as ReactComponent };